/* eslint-disable jsx-a11y/no-redundant-roles */
"use client";

import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import hero_img_full_jpg from "../assets/images/hero-img-full.jpg";
import hero_img_full_webp from "../assets/images/hero-img-full.webp";
import terrain_pattern_lg from "../assets/images/terrain-pattern-lg.webp";
import ScrollReveal from "scrollreveal";

export default function Example() {
  useEffect(() => {
    // only run on the client
    if (typeof window !== "undefined") {
      const sr = ScrollReveal({ reset: false });

      // animate the paragraph
      sr.reveal("#hero p", {
        origin: "left",
        distance: "50px",
        duration: 800,
        delay: 200,
      });

      // stagger the list items
      sr.reveal("#hero ul li", {
        origin: "left",
        distance: "30px",
        duration: 600,
        interval: 150,
        delay: 400,
      });

      // animate both links/buttons
      sr.reveal("#hero a", {
        origin: "bottom",
        distance: "20px",
        duration: 600,
        interval: 100,
        delay: 600,
      });

      // slide in the picture from the right
      sr.reveal("#hero picture", {
        origin: "right",
        distance: "100px",
        duration: 800,
        delay: 300,
      });
    }
  }, []);

  return (
    <div
      id="hero"
      style={{ backgroundImage: `url(${terrain_pattern_lg})` }}
      className="bg-center z-50"
    >
      <div className="relative">
        <div className="mx-auto max-w-7xl">
          <div className="relative z-10 pt-14 lg:w-full lg:max-w-2xl">
            <div className="relative px-6 py-12 sm:py-40 lg:px-8 lg:py-28 lg:pr-0">
              <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-xl">
                {/* removed highlight text per client's request, leaving here just incase they want to add it back or update it */}
                {/* <p className="pb-2 font-united_sans_sm text-base/7 font-semibold text-[#D2B48C]">
                  NORTH CAROLINA ROOFING
                </p> */}
                <h1 className="font-united_sans_lg text-pretty text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
                  HIGHTIDE ROOFING
                </h1>
                <p className="mt-8 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
                  At HighTide Roofing, we are first and foremost committed to
                  the principles of professionalism, honesty, and integrity. We
                  are proud to provide the best roofing services in and around
                  the Port City.
                </p>
                <div className="mt-10 max-w-2xl">
                  <ul
                    role="list"
                    className="text-sm sm:text-base font-united_sans_sm text-bottom mt-8 max-w-xl space-y-8 text-gray-600"
                  >
                    <li className="flex gap-x-3">
                      <CheckCircleIcon
                        aria-hidden="true"
                        className="mt-0.5 size-5 flex-none text-[#D2B48C]"
                      />
                      <span>
                        <strong className="font-semibold text-gray-900">
                          LOCALLY OWNED AND OPERATED
                        </strong>{" "}
                      </span>
                    </li>
                    <li className="flex gap-x-3">
                      <CheckCircleIcon
                        aria-hidden="true"
                        className="mt-0.5 size-5 flex-none text-[#D2B48C]"
                      />
                      <span>
                        <strong className="font-semibold text-gray-900">
                          LICENSED AND INSURED
                        </strong>{" "}
                      </span>
                    </li>
                    <li className="flex gap-x-3">
                      <CheckCircleIcon
                        aria-hidden="true"
                        className="mt-0.5 size-5 flex-none text-[#D2B48C]"
                      />
                      <span>
                        <strong className="font-semibold text-gray-900">
                          INSURANCE CLAIM EXPERTS
                        </strong>{" "}
                      </span>
                    </li>
                    <li className="flex gap-x-3">
                      <CheckCircleIcon
                        aria-hidden="true"
                        className="mt-0.5 size-5 flex-none text-[#D2B48C]"
                      />
                      <span>
                        <strong className="font-semibold text-gray-900">
                          #1 FORTIFIED ROOF INSTALLERS IN NC
                        </strong>{" "}
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="mt-10 flex flex-col items-center gap-y-4 sm:flex-row sm:gap-x-6">
                  <HashLink
                    smooth
                    to="#FreeQuote"
                    className="rounded-md bg-red-700 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    Get HighTide Roofing Today!
                  </HashLink>
                  <Link
                    to="/services"
                    className="text-sm/6 font-semibold text-gray-900"
                  >
                    Learn more <span aria-hidden="true">→</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 clip-path-none lg:[clip-path:polygon(100%_100%,10%_100%,50%_0%,100%_0%)]">
          <picture>
            <source srcSet={hero_img_full_webp} type="image/webp" />
            <img
              alt="Hero"
              src={hero_img_full_jpg}
              className="h-full w-full object-cover"
              // for above-the-fold images, keep loading as 'eager'
              loading="eager"
            />
          </picture>
        </div>
      </div>
    </div>
  );
}
